export default {
    and: 'y',
    option: 'opción',
    options: 'opciones',
    fewer: 'fewer',
    more: 'more',
    pageAvailableIn: 'Esta página está disponible en',
    bookAvailableIn: 'Este libro de texto está disponible en',
    weHaveBooksIn: 'Tenemos libros de texto en',
    weAlsoHave: 'También tenemos libros en',
    getTheBook: 'Obtener el libro',
    summary: 'Resumen',
    recommended: 'Recomendado',
    view: 'Ver',
    viewAll: 'Ver todo',
    'tabs.bookDetails': 'Detalles del libro',
    'tabs.instructorResources': 'Recursos del instructor',
    'tabs.studentResources': 'Recursos para estudiantes',
    'tabs.videos': 'Videos',
    'adoption.book-prompt': '¿Qué libro(s) de texto estás usando actualmente?',
    'adoption.instructions': 'Seleccione los títulos que esté utilizando incluso si el número de edición es diferente.',
    'authors.senior': 'Autores principales',
    'authors.contributing': 'Autores colaboradores',
    'book-selector.select': 'Seleccione hasta {limit}',
    'book-selector.select-more': 'Selecciona hasta {limit} más',
    'contact-info.first-name': 'Nombre',
    'contact-info.last-name': 'Apellido',
    'contact-info.email': 'Dirección de correo electrónico',
    'contact-info.phone': 'Número de teléfono',
    'contact-info.school': 'Nombre de escuela',
    'contact-info.school-not-found': 'No tenemos esa escuela en nuestro sistema.' +
        ' Por favor cuéntanos un poco más sobre esto:',
    'contact-info.school-type-label': '¿Qué tipo de escuela es??',
    'contact-info.school-location-label': '¿Está ubicado en los Estados Unidos?',
    'errata.header': 'Fe de errata',
    'errata.suggest': 'Sugerir una corrección',
    'errata.list': 'Listado de erratas',
    'form.back': 'Atrás',
    'form.next': 'Siguiente',
    'form.submit': 'Enviar',
    'form.step-of': 'Paso {current} de {total}',
    'resources.additional': 'ver los recursos adicionales a continuación',
    'resources.loginToUnlock': 'Inicie sesión para desbloquear',
    'getit.toc': 'Tabla de contenido',
    'getit.webview.link': 'Ver en línea',
    'getit.app': 'Descargar la aplicación',
    'getit.pdf.download': ' Descargar un PDF',
    'getit.pdf.sample': ' muestra',
    'getit.print': 'Solicitar una copia impresa',
    'getit.kindle.header': 'Descargar para Kindle',
    'getit.kindle.disclaimer': 'Como Asociado de Amazon, ganamos con las compras que califican',
    'how-using.how-many': '¿Cuántos estudiantes utilizan {title} cada semestre?',
    'how-using.hint': 'Incluya secciones impartidas por asistentes técnicos que usted supervise',
    'how-using.how-using': '¿Cómo estás usando {title}?',
    'how-using.students-label': 'Estudiantes por semestre',
    'how-using.usage-label': '¿Cómo estás usando este libro?',
    'how-using.core': 'Como libro de texto básico de mi curso',
    'how-using.recommended': 'Como libro de texto opcional/recomendado para mi curso',
    'how-using.outside': 'Para enseñar, dar tutoría o apoyar a los estudiantes fuera del entorno del curso',
    'how-using.self': 'Para mi propio conocimiento u otro trabajo',
    'interest.option.Web search': 'Búsqueda web',
    'interest.option.Colleague': 'Colega',
    'interest.option.Conference': 'Conferencia',
    'interest.option.Email': 'Correo electrónico',
    'interest.option.Facebook': 'Facebook',
    'interest.option.Twitter': 'X',
    'interest.option.Webinar': 'Seminario web',
    'interest.option.Partner organization': 'Organización asociada',
    'interest.how': '¿Cómo se enteró de OpenStax?',
    'interest.select-instruction': 'Seleccione todo lo que corresponda (opcional).',
    'interest.books-prompt': '¿Qué libro(s) de texto estás interesado en usar?',
    'interest.students-prompt': '¿A cuántos estudiantes enseña cada semestre?',
    'expander.fewer': 'ver {optionCount} {options} menos',
    'expander.more': '+ {optionCount} más {options}...',
    'letusknow.text1': 'Suscríbase<br>para más información',
    'letusknow.text2': '¿Utiliza este libro?<br>Háganoslo saber.',
    'printcopy.individual': 'Individuo',
    'printcopy.disclosure': 'Como afiliados de Amazon ganamos con compras calificadas',
    'printcopy.bookstore': 'Libreria',
    'printcopy.audiobook': 'Audiolibro',
    'printcopy.button1': 'Comprar una copia impresa',
    'printcopy.button2': 'Opciones para solicitar',
    'printcopy.audiobook-button': 'Opciones de compra',
    'pubInfo.pdf.heading': 'Última actualización de la versión PDF:',
    'pubInfo.pdf.see': 'Ver las modificaciones en las',
    'pubInfo.pdf.notes': 'Notas de revisión',
    'pubInfo.license': 'El libro {title} de OpenStax tiene la licencia {name} v{version}',
    'pubInfo.license.heading': 'Licencia',
    'pubInfo.pub.pub': 'Fecha de publicación:',
    'pubInfo.pub.web': 'Última actualización de la versión web:',
    'pubInfo.pub.color': 'Color',
    'pubInfo.pub.b-w': 'Blanco y negro',
    'pubInfo.pub.dig': 'Edición digital (PDF)',
    'pubInfo.pub.assignable': 'Assignable courseware',
    'school-type.College/University (4)': 'Facultad/Universidad (4)',
    'school-type.Technical/Community College (2)': 'Colegio técnico/comunitario (2)',
    'school-type.Career School/For-Profit (2)': 'Escuela profesional/Con fines de lucro (2)',
    'school-type.High School': 'Escuela secundaria',
    'school-type.K-12 School': 'Escuela K-12',
    'school-type.Home School': 'Escuela en casa',
    'school-type.Other': 'Otro',
    'selector.select-one': 'Por favor, seleccione uno',
    'student-form:message': 'Los estudiantes no necesitan completar ningún formulario para usar ' +
        'nuestros libros. ¡Accede a ellos gratis ahora!',
    'student-form:go-back': 'Regresa',
    'subject.categoryTitle': 'Categorías de libros de {subjectName}',
    'subject.learnMoreTitle': 'Aprende más',
    'subject.introText': 'Libros de texto abiertos',
    'subject.noBlog': 'No se encontraron entradas de blog (aún)',
    'subject.noWebinars': 'No se encontraron seminarios web (aún)',
    'subject.viewAll': 'Ver todos los libros de {subject}',
    'subject.notAvailableText': 'Tema no disponible.',
    'subject.notAvailableLinkText': 'Ver todo',
    'resources.available': 'Solo está disponible para instructores verificados.',
    'role-selector.i-am': 'Soy',
    'yes': 'Sí',
    'no': 'No'
};
